import mileageInputValidationSchema from "common/validation/mileageInputValidationSchema";
import regNumberInputValidationSchema from "common/validation/regNumberInputValidationSchema";
import { object } from "zod";

export const partExchangeSchema = object({
    mileage: mileageInputValidationSchema,
    registration_number: regNumberInputValidationSchema,
});
